import angular from 'angular';

import './assigned_device';
import './device';

angular
    .module("merchant.application.main")
    .factory("merchant.application.main.factory.standalonePosDevice", [
        "merchant.application.main.factory.assignedDevice",
        "merchant.application.main.factory.device",
        function (AssignedDevice, Device) {

            var expose = {};

            expose.isDeviceActivated = function () {
                return !!(Device.deviceId() && Device.deviceKey());
            };

            expose.hasDevice = function () {
                return expose.isStandalonePosDeviceAssigned() || expose.isDeviceActivated();

            };

            expose.getAssignedStandalonePosDevice = function () {
                return AssignedDevice.standalonePosDevice();
            };

            expose.isStandalonePosDeviceAssigned = function () {
                var assignedPosDevice = expose.getAssignedStandalonePosDevice();
                return !!(assignedPosDevice && assignedPosDevice.deviceId);
            };

            expose.init = function (tokenErrorHandler, loginErrorHandler) {
                if (!expose.isStandalonePosDeviceAssigned()) {
                    Device.retrieveToken(tokenErrorHandler, loginErrorHandler);
                }
            };

            expose.deviceId = function () {
                var assignedPosDevice = expose.getAssignedStandalonePosDevice();
                return (assignedPosDevice && assignedPosDevice.deviceId) || Device.deviceId();
            };
            expose.deviceName = function () {
                var assignedPosDevice = expose.getAssignedStandalonePosDevice();
                return (assignedPosDevice && assignedPosDevice.deviceName) || Device.deviceName();
            };
            expose.storeName = function () {
                var assignedPosDevice = expose.getAssignedStandalonePosDevice();
                return (assignedPosDevice && assignedPosDevice.storeName) || Device.storeName();
            };

            expose.posUserAuthorizationUrl = Device.posUserAuthorizationUrl;

            expose.redeemBarcode = function (parameters, successHandler, errorHandler) {
                Device.redeemBarcode(
                    parameters,
                    expose.isStandalonePosDeviceAssigned() ? expose.deviceId() : undefined,
                    successHandler,
                    errorHandler
                );
            };

            return expose;

        }
    ]);
